import React from 'react';

import {Edit} from 'react-admin';
import RubricForm from "./RubricForm";

const RubricEdit = (props) => (
    <Edit {...props}><RubricForm/></Edit>
);

export default RubricEdit;
